import { HttpClient } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { collection, collectionData, doc, docData, Firestore, limit, query, runTransaction, where } from '@angular/fire/firestore';
import { ElasticSearchService, ESExtras } from '@common/api-server';
import { EsFirestoreBase } from '@common/helpers/es-firestore-base';
import { firstValueFrom, Observable } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';

const ES_EXTRA: ESExtras = {

}

const ES_SOURCE = null; //['status']

@Injectable({
  providedIn: 'root'
})


export class SettingDbService extends EsFirestoreBase<any> {
  override collectionName = 'settings';
  constructor(
    @Optional() protected override  firestore: Firestore,
    protected override  es: ElasticSearchService,
  ) {
    super(firestore, es, 'settings', ES_EXTRA, ES_SOURCE);
  }

  getPathAll$(path): Observable<any[]> {
    const _collection = collection(this.firestore, `${this.collectionName}/${path}`).withConverter(this.genericConverter);
    const _query = query(_collection, limit(100))
    return collectionData(_query, { idField: 'id' }) as Observable<any[]>;
  }

  nextCount = (counter): Promise<number>  => {
    const docRef = doc(this.firestore, this.collectionName, 'counters');

    return runTransaction(this.firestore, async (transaction) => {
      const countersDoc = await transaction.get(docRef);
      const newCounterValue = countersDoc.data()[counter] + 1;
      transaction.update(docRef, { [counter]: newCounterValue });
      return newCounterValue;
    })
  }


}
